import axios from '../../localAxios';
import { joinWorkspaceURL, workspaceByCodeURL } from '../workspacesURLs';

interface GetWorkspaceByCodeParams {
  workspaceCode: string;
}

export async function getWorkspaceByCode({
  workspaceCode,
}: GetWorkspaceByCodeParams) {
  const result = await axios.get(workspaceByCodeURL(workspaceCode).href);
  return result.data;
}

interface JoinWorkspaceParams {
  workspaceCode: string;
  workspaceId: string;
}

export async function joinWorkspace({
  workspaceCode,
  workspaceId,
}: JoinWorkspaceParams) {
  const result = await axios.post(joinWorkspaceURL().href, {
    workspace_code: workspaceCode,
    workspace_id: workspaceId,
  });
  return result.data;
}
